var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useCallback, useMemo } from 'react';
import clsx from 'clsx';
import { XBox } from '../box/XBox';
import { useImmer } from 'use-immer';
import { XButton } from '../button/XButton';
export function XFormInput(_a) {
    var _b = _a.type, type = _b === void 0 ? 'string' : _b, value = _a.value, label = _a.label, placeholder = _a.placeholder, options = _a.options, helperText = _a.helperText, onChangeValue = _a.onChangeValue, selectProps = _a.selectProps, inputProps = _a.inputProps, adornmentStart = _a.adornmentStart, adornmentStartIcon = _a.adornmentStartIcon, adornmentEnd = _a.adornmentEnd, adornmentEndIcon = _a.adornmentEndIcon, ref = _a.ref, disabled = _a.disabled;
    var id = useState((inputProps === null || inputProps === void 0 ? void 0 : inputProps.id) || (selectProps === null || selectProps === void 0 ? void 0 : selectProps.id) || Math.random().toString())[0];
    var _c = useImmer({
        interacted: false,
        changed: false,
    }), inputState = _c[0], setInputState = _c[1];
    var setInputStateChanged = useCallback(function () {
        setInputState(function (state) {
            state.changed = true;
        });
    }, []);
    var inputPropsCombined = __assign({ id: id, placeholder: placeholder, disabled: disabled, ref: ref, type: type }, inputProps);
    var inputType = inputPropsCombined.type;
    if (type === 'string') {
        inputType = 'text';
    }
    else if (['number', 'integer', 'currency'].includes(type)) {
        inputType = 'number';
        if (type === 'integer') {
            inputPropsCombined.step = 1;
        }
    }
    else if (type === 'search') {
        inputType = 'text';
    }
    if (options) {
        inputType = 'select';
    }
    var formattedValue = useMemo(function () {
        switch (type) {
            case 'number':
                return value !== null && value !== void 0 ? value : '';
            case 'currency':
                return value !== null && value !== void 0 ? value : '';
            //case 'currency':
            //    return String((value || 0) / 100);
            default:
                return value;
        }
    }, [type, value]);
    function handleChange(event) {
        setInputStateChanged();
        var targetValue = event.target.value;
        switch (inputType) {
            case 'string':
            case 'search':
            default:
                return onChangeValue(targetValue);
            case 'currency':
                var value_1 = targetValue || 0;
                onChangeValue(Number(value_1) * 100);
                return;
            case 'number':
                if (targetValue === '') {
                    return onChangeValue(null);
                }
                else {
                    return onChangeValue(Number(targetValue));
                }
            case 'select':
                if (targetValue === '') {
                    return onChangeValue(null);
                }
                else {
                    return onChangeValue(targetValue);
                }
                return;
            case 'boolean':
                return;
        }
    }
    var hasAdornmentStart = Boolean(adornmentStart || adornmentStartIcon);
    var hasAdornmentEnd = Boolean(adornmentEnd || adornmentEndIcon);
    return (React.createElement("label", { htmlFor: id, className: clsx('XFormInput', __assign({ hasAdornmentStart: hasAdornmentStart,
            hasAdornmentEnd: hasAdornmentEnd,
            disabled: disabled }, inputState)) },
        label && React.createElement("div", { className: "label" }, label),
        React.createElement(XBox, { flex: true, align: "center", className: "input-container" },
            hasAdornmentStart && (React.createElement("div", { className: "adornment start" },
                adornmentStart,
                adornmentStartIcon && React.createElement(XButton, { icon: adornmentStartIcon }))),
            inputType === 'select' ? (React.createElement("select", __assign({}, selectProps, { value: value, onChange: handleChange }),
                React.createElement("option", { value: '' }, placeholder),
                (options || []).map(function (option) { return (React.createElement("option", { key: option.value, value: option.value }, option.label)); }))) : (React.createElement("input", __assign({}, inputPropsCombined, { value: formattedValue, onClick: function (event) {
                    var _a;
                    setInputState(function (state) {
                        state.interacted = true;
                    });
                    (_a = inputPropsCombined.onClick) === null || _a === void 0 ? void 0 : _a.call(inputPropsCombined, event);
                }, onChange: handleChange, type: inputType }))),
            hasAdornmentEnd && (React.createElement("div", { className: "adornment end" },
                adornmentEnd,
                adornmentEndIcon && React.createElement(XButton, { icon: adornmentEndIcon })))),
        helperText && React.createElement("div", { className: 'helperText' }, helperText)));
}
